//      
import React from "react";
import "./Loading.scss";
import Spinner from "react-spinkit";

                      

const Loading = (props              ) => {
	return <div className={"sl-loading"}><Spinner name="ball-beat"/></div>;
};

export default Loading;
